import {
    Box,
    Flex,
    Heading,
} from "@chakra-ui/react";
import { PermissionsTable } from "../../components/permissions-table/permissions-table.comp";

export function PermissionsList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Permissions</Heading>
            </Flex>
            <PermissionsTable />
        </Box>
    );
}
